import client from "./client";

const teachersApi = {
  list(params = {}) {
    return client.get("/teachers", { params }).then((r) => r.data);
  },

  get(id) {
    return client.get(`/teachers/${id}`).then((r) => r.data);
  },

  create(body) {
    return client.post("/teachers", body).then((r) => r.data);
  },

  update(id, body) {
    return client.patch(`/teachers/${id}`, body).then((r) => r.data);
  },

  setEmploymentStatus(id, employmentStatus) {
    return client.patch(`/teachers/${id}/employment-status`, { employmentStatus }).then((r) => r.data);
  },

  assignClasses(id, assignedClasses) {
    return client.patch(`/teachers/${id}/assign-classes`, { assignedClasses }).then((r) => r.data);
  },

  assignClassTeacher(id, className) {
    return client.patch(`/teachers/${id}/assign-class-teacher`, { className }).then((r) => r.data);
  },

  removeClassTeacher(id) {
    return client.patch(`/teachers/${id}/remove-class-teacher`).then((r) => r.data);
  },

  checkin(id, body) {
    return client.post(`/employee-attendance/checkin`, body).then((r) => r.data);
  },

  markAttendance(body) {
    return client.post("/teachers/attendance", body).then((r) => r.data);
  },
};

export default teachersApi;
